import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPipelineStatsData } from '../../../../redux/prospect-reducers/prospectSlice';
import PipelineStageCard from './PipelineStageCard';
import ReactVortoxSpinner from '../../../common-components/ReactVortoxSpinner';

const PipelineStagesOverview = ({ userInfoData }) => {
  const dispatch = useDispatch();
  const { pipelineStats, pipelineStatsLoading } = useSelector((state) => state?.prospects);

  const isAdmin = userInfoData?.account_type === "admin";
  const isMarketing = userInfoData?.account_type === "marketing";
  const isClusterManager = userInfoData?.account_type === "cluster_manager";

  // filters for API call
  const initialFilters = {
    gym_id: !isAdmin && !isMarketing && !isClusterManager ? userInfoData?.gym_id || "" : "",
  };
  const [filters, setFilters] = useState(initialFilters);

  // useEffect(() => {
  //   setFilters((prev) => ({
  //     ...prev,
  //     gym_id: userInfoData?.gym_id || "",
  //   }));
  // }, [userInfoData?.gym_id]);

  // Fetch pipeline stats data when token and filters are ready
  useEffect(() => {
    if (!userInfoData?.token) return;
    dispatch(
      fetchPipelineStatsData({
        filters,
        token: userInfoData?.token,
      })
    );
  }, [dispatch, userInfoData?.token, filters]);


  return (
    <div className="lms-closure-pipeline-tracker-stages-overview">
      <div className="lms-closure-pipeline-tracker-stages-container">
        {pipelineStatsLoading ? (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 140 }}>
            <ReactVortoxSpinner />
          </div>
        ) : pipelineStats?.data?.length > 0 ? (
          pipelineStats?.data?.map((stage, index) => {
            const getBackgroundClass = (stageName) => {
              const name = stageName?.toLowerCase() || "";
              if (name.includes("closed won") || name.includes("closedwon")) {
                return "green";
              } else if (name.includes("closure expected") || name.includes("closureexpected")) {
                return "blue";
              } else {
                return "orange";
              }
            };

            return (
              <PipelineStageCard
                key={stage?.stage || index}
                stage={{
                  name: stage?.stage || "Unknown Stage",
                  count: stage?.total_leads || "0",
                  value: stage?.total_revenue || "0",
                }}
                isLast={index === pipelineStats?.data?.length - 1}
                background={getBackgroundClass(stage?.stage)}
              />
            );
          })
        ) : ""}
      </div>
    </div>
  );
};

export default PipelineStagesOverview; 